import { getLenis } from '../components/lenis-scroll';

import {
    injectFoucStyles,
    scheduleScrollRestorationSync,
    setupScrollTrigger,
    teardownScrollTrigger,
} from './_shared';
import { Parallax } from './parallax';
import { ScrollReveal } from './scroll-reveal';
import { SlideUnder } from './slide-under';
import { Stagger } from './stagger';

export function initMdaGsap(root = document) {
    injectFoucStyles();
    const lenis = getLenis();
    setupScrollTrigger(lenis);

    const instances = {
        parallax: Parallax.init(root),
        scrollReveal: ScrollReveal.init(root),
        slideUnder: SlideUnder.init(root),
        stagger: Stagger.init(root),
    };

    scheduleScrollRestorationSync(lenis);

    return instances;
}

export function destroyMdaGsap(instances) {
    if (!instances) {
        return;
    }

    Object.values(instances).forEach(group => {
        if (Array.isArray(group)) {
            group.forEach(instance => {
                instance?.destroy?.();
            });
            return;
        }

        group?.destroy?.();
    });

    teardownScrollTrigger();
}
